export * from './switch';



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/switch/index.ts